import React, { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { CardBody } from "../../../../../_metronic/_partials/controls"
import { useSubheader } from "../../../../../_metronic/layout"
import { FileList, RowText } from "../../../../../component"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants"
import { RoutesConstants } from "../../../../../constants/RoutesConstants"
import { DATE_TYPE_ENUM } from "../../../../../constants/StringConstant"
import { getDetailLandClearing } from "../../../../../redux/actions/AreaAction"
import { timeStampToDate } from "../../../../helpers/DateHelper"
import {
  stringFormatting,
  convertM2ToHectareParseFloat,
  fileTypeSplit
} from "../../../../helpers/TextHelper"

export function LandClearingDetail({
  match: {
    params: { status, id, activityId }
  }
}) {
  const { Area } = useSelector((state) => state)
  const { t } = useTranslation()
  const [data, setData] = useState()
  const subHeader = useSubheader()
  const dispatch = useDispatch()

  useEffect(() => {
    if (activityId) {
      dispatch(getDetailLandClearing(activityId))
    }
  }, [activityId])

  useEffect(() => {
    if (Area?.data) {
      setData(Area?.data)
    }
  }, [Area.data])

  useEffect(() => {
    subHeader.setButton(null)
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
        title: t("label_area_name")
      },
      {
        pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
        title: t("label_registered")
      },
      {
        pathname: RoutesConstants.AREA.DETAIL_AREA(status, id),
        title: data?.area_information?.area_name
      },
      {
        title: t("label_clearing")
      }
    ])
  }, [data])

  function headerData() {
    return (
      <ActivityDetailHeader
        title={t("label_land_clearing_activity")}
        icon={ICON_CONSTANTS.ACTIVITY_ICONS.HATCHERY}
      />
    )
  }
  return (
    <div style={{ display: "grid", gap: 16 }}>
      {headerData()}
      <Card>
        <CardBody>
          <h4 className={"mb-6 text-uppercase"}>{t("label_area_information")}</h4>
          <div className={"row mb-2"}>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_area_name")}
                value={stringFormatting(data?.area_information?.area_name)}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_area_location")}
                value={stringFormatting(data?.area_information?.full_address)}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_block_name")}
                value={stringFormatting(data?.area_information?.block_code)}
              />
            </div>

            <div className={"col-md-6"}>
              <RowText
                label={t("label_manual_area_size")}
                value={
                  data?.area_information?.area_land_manual
                    ? `${convertM2ToHectareParseFloat(
                        data?.area_information?.area_land_manual,
                        4
                      )} Ha`
                    : "-"
                }
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_certification_number")}
                value={stringFormatting(data?.area_information?.certification_number)}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_polygon_area_size")}
                value={
                  data?.area_information?.area_land_polygon
                    ? `${convertM2ToHectareParseFloat(
                        data?.area_information?.area_land_polygon,
                        4
                      )} Ha`
                    : "-"
                }
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_farmer")}
                value={`${stringFormatting(
                  data?.area_information?.farmer_name
                )} (${stringFormatting(data?.area_information?.farmer_code)})`}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_plant_type")}
                value={stringFormatting(data?.area_information?.plant_type_name)}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_mitra")}
                value={`${stringFormatting(data?.area_information?.mitra_name)} (${stringFormatting(
                  data?.area_information?.mitra_code
                )})`}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_plant_varieties")}
                value={stringFormatting(data?.area_information?.variety_name)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <h4 className={"mb-6 text-uppercase"}>{t("label_land_clearing_data")}</h4>
          <div className={"row mb-2"}>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_created_by")}
                value={stringFormatting(data?.land_clearing?.created_by)}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_age_at_activity")}
                value={stringFormatting(data?.land_clearing?.hst) + " HST"}
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_created_date")}
                value={
                  data?.land_clearing?.created_date
                    ? timeStampToDate(
                        data?.land_clearing?.created_date,
                        DATE_TYPE_ENUM.ISO_DATETIME_STRAP
                      )
                    : "-"
                }
              />
            </div>

            <div className={"col-md-6"}>
              <RowText
                label={t("label_land_area_worked")}
                value={
                  data?.land_clearing?.worked_area
                    ? `${convertM2ToHectareParseFloat(data?.land_clearing?.worked_area)} Ha`
                    : "-"
                }
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_activity_date")}
                value={
                  data?.land_clearing?.activity_date
                    ? timeStampToDate(
                        data?.land_clearing?.activity_date,
                        DATE_TYPE_ENUM.ISO_DATE_STRAP
                      )
                    : "-"
                }
              />
            </div>
            <div className={"col-md-6"}>
              <RowText
                label={t("label_land_clearing_reasong")}
                value={stringFormatting(data?.land_clearing?.reason_string)}
              />
            </div>
          </div>
          <h4 className={"mb-6 "}>{t("event_report")}</h4>
          <div>
            {data && (
              <FileList
                view={stringFormatting(data?.land_clearing?.document_url)}
                className={"mb-5 col-md-6"}
                name={stringFormatting(data?.land_clearing?.document_name)}
                size={stringFormatting(data?.land_clearing?.document_size)}
                type={fileTypeSplit(stringFormatting(data?.land_clearing?.document_name))}
              />
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}